var React = require('react');

function CheckBullet (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_awesome-check-circle","data-name":"Icon awesome-check-circle","d":"M50.234,25.234a25,25,0,1,1-25-25A25,25,0,0,1,50.234,25.234ZM22.343,38.472,40.891,19.923a1.613,1.613,0,0,0,0-2.281L38.61,15.361a1.613,1.613,0,0,0-2.281,0L21.2,30.488,14.14,23.426a1.613,1.613,0,0,0-2.281,0L9.578,25.707a1.613,1.613,0,0,0,0,2.281L20.062,38.472A1.613,1.613,0,0,0,22.343,38.472Z","transform":"translate(-0.234 -0.234)","fill":"#fff"}));
}

CheckBullet.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50"};

module.exports = CheckBullet;

CheckBullet.default = CheckBullet;
